import { Component } from '@angular/core';
import { ModalService } from '../../services/modal.service';

@Component({
  selector: 'ng-casto-generic-error',
  templateUrl: './generic-error.component.html',
})
export class GenericErrorComponent {
  errorMessage: string;

  constructor(public modalService: ModalService) {
    this.errorMessage = this.modalService.currentDatas.errorMessage;
  }
}
